import React from "react";

// import "../../../src/assets/css/screens/serviceprovider/dashboard/subscription/WorkerSubHistory.css";
import "../../assets/css/components/skeletoloadig/WorkerSubscriptionHistorySkeleton.css";
import WorkerNavbar from "../../components/serviceprovider/workerdashboard/Workernavbar/WorkerBottomNav";

const WorkerSubscriptionHistorySkeleton = () => {

    return (
        <>
            <WorkerNavbar />

            <div className="wsh-sk-page">

                {/* Mobile Header */}
                <div className="wsh-sk-mob-header d-md-none skeleton">
                    <div className="wsh-sk-back-btn"></div>

                    <div style={{ flex: 1 }}>
                        <div className="sk-line sk-title skeleton"></div>
                        <div className="sk-line sk-small"></div>
                    </div>
                </div>

                <div className="wsh-sk-container">

                    {/* Desktop Header */}
                    <div className="wsh-sk-desk-header">
                        <div style={{ width: "100%" }}>
                            <div className="sk-line sk-title skeleton"></div>
                            <div className="sk-line sk-small"></div>
                        </div>
                    </div>

                    {/* Current Subscription */}
                    <div className="wsh-sk-current-card skeleton">

                        <div className="wsh-sk-current-card__top">

                            <div className="wsh-sk-current-card__left">

                                <div className="wsh-sk-current-card__icon"></div>

                                <div>
                                    <div className="sk-badge"></div>
                                    <div className="sk-line sk-small mt-2"></div>
                                </div>

                            </div>

                            <div>
                                <div className="sk-price"></div>
                            </div>

                        </div>

                        {/* Countdown */}

                        <div className="sk-line sk-small"></div>

                        <div className="wsh-sk-countdown">

                            {[1,2,3,4].map((i)=>(
                                <div
                                    key={i}
                                    className="wsh-sk-countdown-unit skeleton"
                                >
                                    <div className="sk-count"></div>
                                    <div className="sk-mini"></div>
                                </div>
                            ))}

                        </div>

                        {/* Progress */}

                        <div className="wsh-sk-progress-wrap">

                            <div className="sk-date"></div>

                            <div className="wsh-sk-progress-bar">
                                <div
                                    className="wsh-sk-progress-fill"
                                    style={{width:"45%"}}
                                />
                            </div>

                            <div className="sk-date"></div>

                        </div>

                        <div className="sk-line sk-mini"></div>

                        {/* Features */}

                        <div className="wsh-sk-current-features">

                            {[1,2,3].map((i)=>(
                                <div
                                    key={i}
                                    className="sk-feature"
                                ></div>
                            ))}

                        </div>

                        {/* Button */}

                        <div className="wsh-sk-upgrade-btn skeleton"></div>

                    </div>

                    {/* History */}

                    <div className="wsh-sk-history-section">

                        <div className="wsh-sk-history-header">

                            <div className="sk-line sk-title skeleton"></div>

                            <div style={{display:"flex",gap:"8px"}}>
                                <div className="sk-tab"></div>
                                <div className="sk-tab"></div>
                            </div>

                        </div>

                        {[1,2,3,4].map((i)=>(

                            <div
                                className="wsh-sk-history-item skeleton"
                                key={i}
                            >

                                <div className="wsh-sk-history-item__left">

                                    <div className="wsh-sk-history-item__icon"></div>

                                    <div style={{flex:1}}>

                                        <div className="sk-line sk-medium"></div>

                                        <div className="sk-line sk-small"></div>

                                        <div className="sk-line sk-mini"></div>

                                    </div>

                                </div>

                                <div>

                                    <div className="sk-price-sm"></div>

                                    <div className="sk-mini mt-2"></div>

                                </div>

                            </div>

                        ))}

                    </div>

                    <div className="sk-footer"></div>

                </div>

            </div>
        </>
    );
};

export default WorkerSubscriptionHistorySkeleton;